import React from 'react';

import { Button, ButtonProps } from '@mui/material';

import { angularizeWithProviders } from '../../../shared/providers';

type AddEntityButtonProps = Pick<ButtonProps, 'variant' | 'size'>;

const AddEntityButton = ({ size, variant = 'contained' }: AddEntityButtonProps) => {
  return (
    <Button size={size} variant={variant} href="#!/entity-setup-flow-2024">
      Add a New Entity
    </Button>
  );
};

angularizeWithProviders(AddEntityButton, 'ngzAddEntityButton', {
  size: '=',
  variant: '=',
});

export { AddEntityButton };
